var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footprint"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('me.footprint.title')))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('me.footprint.subtitle')))]),_c('div',{staticClass:"content"},[_c('foot-slides')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }